import config from '../../config';
import readXLSXFromUrl from '@common/xlsxExport/utils/readXLSXFromUrl';
import downloadXlsxFile from '../../shared/xlsxExport/downloadXlsxFile';

import { generateAssetPath } from '../../utils/assetsHelpers';
import { formatWorkbook } from '@common/xlsxExport/utils/formatWorkbook';

const generateTemplateRow = ({ periodName, companyCodeData } = {}) =>
  [periodName, companyCodeData.companyCode, null, companyCodeData.functionalCurrency];

export const generateXlsxTemplateForCompany = async ({ adjustmentPeriod, companyCodeData, environmentSuffix } = {}) => {
  const url = generateAssetPath(config.templates.BEGINNING_BALANCE_ES);

  const template = await readXLSXFromUrl(url);

  const formattedSheets = formatWorkbook(template);

  const additionalRow = generateTemplateRow(
    {
      periodName: adjustmentPeriod,
      companyCodeData,
    }
  );

  formattedSheets[0].grid = formattedSheets[0].grid.concat([additionalRow]);

  downloadXlsxFile(`TLS_Beginning_Balance_${adjustmentPeriod}_${companyCodeData.companyCode}${environmentSuffix}`, formattedSheets);
};

export const generateXlsxTemplateForConnection = async ({
  periodName,
  connectionTemplateDetails,
  templateUrl,
} = {}) => {
  const template = await readXLSXFromUrl(templateUrl);

  const formattedSheets = formatWorkbook(template);

  const additionalRows = connectionTemplateDetails.map(companyCodeData => generateTemplateRow(
    {
      periodName,
      companyCodeData,
    }
  ));

  formattedSheets[0].grid = formattedSheets[0].grid.concat(additionalRows);

  return formattedSheets;
};


export const generateAndDownloadXlsxTemplateForConnectionBeginningBalances = async ({
  adjustmentPeriod,
  connection,
  connectionTemplateDetails,
  environmentSuffix,
}) => {
  const templateUrl = generateAssetPath(config.templates.BEGINNING_BALANCE_ES);

  const generatedTemplate = await generateXlsxTemplateForConnection({
    periodName: adjustmentPeriod,
    connection,
    connectionTemplateDetails,
    environmentSuffix,
    templateUrl,
  });

  downloadXlsxFile(`TLS_Beginning_Balance_${adjustmentPeriod}_${connection}${environmentSuffix}`, generatedTemplate);
};
